/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\ToTopButton\ToTopButton.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday June 21st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 30th June 2023 12:29:48
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */


import { Fragment, useEffect, useState } from 'react';
import styles from 'Content/ToTopButton/ToTopButton.module.css';
import { TbArrowBigUpLine } from "react-icons/tb";

function ToTopButton() {
    const [backToTop, setBackToTop] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 300)
                setBackToTop(true);
            else
                setBackToTop(false);
        })
    });

    const scrollUp = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return(
        <Fragment>
                {
                    backToTop ?
                        <div className={`${styles.scrollTop}`}>
                            <button onClick={scrollUp}> <TbArrowBigUpLine size={"2rem"}/> </button>
                        </div>
                        :null
                }
        </Fragment>
    );
}

export default ToTopButton;
